declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_array_with_types_foo extends $mol_object {
		arr( ): readonly(readonly(number)[])[]
	}
	
}

//# sourceMappingURL=array_with_types.view.tree.d.ts.map